import { Map } from 'immutable'
import { createSelector } from 'reselect'

import { getDevFlags, LDFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

export const getFeatureFlagState = (state: Map<string, any>) => state?.get('featureFlag')

export const getFeatureFlags = createSelector([getFeatureFlagState], (featureFlagState) => ({
  ...(featureFlagState.get('flags').toJS() as LDFlags),
  ...getDevFlags(),
}))

export const getAdultTriageDisabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.adultTriageDisabled,
)

export const getForceAdultFlowsToHPI = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.forceAdultFlowsToHPI,
)

export const getIsCustomerDynamicSessionLimitFeatureFlagEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isCustomerDynamicSessionLimitEnabled,
)

export const getIsCopayForMaxCostEstimateEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isCopayForMaxCostEstimateEnabled,
)

export const getIsWellnessGoalsEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isWellnessGoalsEnabled,
)

export const getIsTrsSearchLocationDataEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isTrsSearchLocationDataEnabled,
)

export const getIsFavoritedProvidersEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isFavoritedProvidersEnabled,
)

export const getForkedTriageV2Enabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.forkedTriageV2Enabled,
)

export const getShouldShowWalmartHPICostTransparency = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.shouldShowWalmartHPICostTransparency,
)

export const getIsClientDisabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isClientDisabled,
)

export const getIsLyraForLyrians2026Enabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isLyraForLyrians2026Enabled,
)

export const getIsPromotionalSMSEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isPromotionalSMSEnabled,
)

export const getShouldHideHealthPlanPrompt = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.shouldHideHealthPlanPrompt,
)

export const getIsStripeTextToPayEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isStripeTextToPayEnabled,
)

export const getShowProviderAdjectives = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.showProviderAdjectives,
)

export const getIsEapHpiInProductNotificationsEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isEapHpiInProductNotificationsEnabled,
)

export const getIsLCTTeensAdditionalRemindersEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isLCTTeensAdditionalRemindersEnabled,
)

export const getIsAuthenticatorMFAEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isAuthenticatorMFAEnabled,
)

export const getIsOnsiteEligibleResponseEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isOnsiteEligibleResponseEnabled,
)
